import { render, staticRenderFns } from "./DefectConfiguration.vue?vue&type=template&id=7b9d224a&"
import script from "./DefectConfiguration.vue?vue&type=script&lang=js&"
export * from "./DefectConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports